<template functional>
  <div class="f-col ctr welcome">
    <div class="f-col full welcome-wrapper">
      <div class="f-row ctr alert-header">
        <Icon class icon="meteor" />
        <span>Seja bem-vindo</span>
      </div>
      <div class="f-col ctr welcome-container">
        <router-link class="f-row ctr editor-btn" to="/editor"
          >Ir para sites</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome",
};
</script>

<style scoped>
.welcome {
  min-width: 260px;
  max-width: 600px;
  margin: 0 auto;
  padding-bottom: 2px;
  border: 1px solid #ccc;
  color: #555;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1);
  line-height: 1;
}

.welcome-wrapper {
  border-radius: 0.25rem;
  overflow: hidden;
}

.alert-header {
  padding: 10px 0;
  margin-bottom: 2px;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  color: #fbfbfb;
  background: #3e4e5e;
}

.alert-header > svg {
  font-size: 18px;
  margin-right: 8px;
}

.welcome-container {
  margin: 5px 10px;
  font-size: 16px;
}

.welcome-container > p {
  margin: 10px 0;
  text-align: justify;
  line-height: 1.5;
}

.editor-btn {
  height: 42px;
  width: 160px;
  margin: 12px;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  color: #f1f1f1;
  background: #159ad1;
  border-radius: 0.25rem;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
}
</style>